<div
  class="association-picker"
  [ngClass]="
    showOtherSidePicker ? 'no-form-field-padding' : 'less-form-field-padding'
  "
>
  <div>
    <div class="title">Telefoonnummer</div>
    <mat-form-field appearance="outline">
      <mat-select
        matInput
        placeholder="Telefoonnummer"
        [(ngModel)]="selectedPhoneNumberOption"
        [compareWith]="compareOptions"
        (selectionChange)="selectedPhoneNumberOptionChanged()"
      >
        <mat-option
          *ngFor="let option of phoneNumberOptions"
          [value]="option"
          >{{ option.label }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>
  <div
    *ngIf="showOtherSidePicker || leftRightBoard"
    class="side-label left-label"
  >
    {{ label }}
  </div>
  <div
    *ngIf="selectedPhoneNumberOption?.id === OTHER_PHONE_NUMBER_ID"
    class="other-value-input top-margin"
  >
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Gewenst telefoonnummer"
        [(ngModel)]="ipBoardPart.otherPhoneNumber"
        (ngModelChange)="otherPhoneNumberChanged()"
      />
    </mat-form-field>
  </div>
</div>
<div
  *ngIf="showOtherSidePicker"
  class="association-picker less-form-field-padding"
>
  <mat-form-field appearance="outline">
    <mat-select
      matInput
      placeholder="Telefoonnummer"
      [(ngModel)]="selectedOtherSidePhoneNumberOption"
      [compareWith]="compareOptions"
      (selectionChange)="selectedOtherSidePhoneNumberOptionChanged()"
    >
      <mat-option *ngFor="let option of phoneNumberOptions" [value]="option">{{
        option.label
      }}</mat-option>
    </mat-select>
  </mat-form-field>
  <div *ngIf="showOtherSidePicker" class="side-label">
    Rechts
  </div>
  <div
    *ngIf="selectedOtherSidePhoneNumberOption?.id === OTHER_PHONE_NUMBER_ID"
    class="other-value-input"
  >
    <mat-form-field appearance="outline">
      <input
        matInput
        placeholder="Gewenst telefoonnummer"
        [(ngModel)]="ipBoardPart.otherSideOtherPhoneNumber"
        (ngModelChange)="otherSideOtherPhoneNumberChanged()"
      />
    </mat-form-field>
  </div>
</div>
<div
  class="left-fifteen-space"
  *ngIf="
    ipBoardPart.boardType?.ordinal === BOARD_TYPE_CHOICES.V.ordinal &&
    !leftRightBoard
  "
>
  <mat-checkbox
    [(ngModel)]="showOtherSidePicker"
    (ngModelChange)="showOtherSidePickerChanged()"
    ><span class="smaller-text"
      >Links/Rechts bord afzonderlijk v/e telnr voorzien</span
    ></mat-checkbox
  >
</div>
